<div *ngIf="normalizedConfig" class="feature-comparison-renderer">
  <div class="renderer-header">
    <div class="renderer-copy">
      <h3 class="renderer-title">{{ normalizedConfig.title }}</h3>
      <p class="renderer-subtitle" *ngIf="normalizedConfig.subtitle">{{ normalizedConfig.subtitle }}</p>
    </div>

    <div class="billing-toggle" *ngIf="showBillingToggle">
      <button
        type="button"
        class="billing-toggle__button"
        [class.is-active]="activeBillingMode === 'monthly'"
        (click)="activeBillingMode = 'monthly'">
        {{ normalizedConfig.billing.monthlyLabel }}
      </button>
      <button
        type="button"
        class="billing-toggle__button"
        [class.is-active]="activeBillingMode === 'annual'"
        (click)="activeBillingMode = 'annual'">
        {{ normalizedConfig.billing.annualLabel }}
      </button>
    </div>
  </div>

  <div class="renderer-table-shell">
    <div class="renderer-scroll">
      <table class="renderer-table">
        <thead>
          <tr>
            <th class="renderer-table__feature">{{ normalizedConfig.featureColumnTitle }}</th>
            <th *ngFor="let plan of plans; trackBy: trackById" class="renderer-table__plan">
              <div class="plan-header">
                <h4>{{ plan.name }}</h4>
                <p *ngIf="plan.description">{{ plan.description }}</p>
                <div class="plan-price" *ngIf="getPlanPriceLabel(plan)">{{ getPlanPriceLabel(plan) }}</div>
                <small *ngIf="plan.featured" class="plan-meta">Destacado</small>
                <small *ngIf="getPlanRedirectLabel(plan)" class="plan-meta">Accion: {{ getPlanRedirectLabel(plan) }}</small>
                <small *ngIf="plan.redirectUrl" class="plan-meta">Destino: {{ plan.redirectUrl }}</small>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let feature of features; trackBy: trackById">
            <td class="renderer-table__feature-row">
              <strong>{{ feature.label }}</strong>
            </td>

            <td *ngFor="let plan of plans; trackBy: trackById" class="renderer-table__value">
              <span *ngIf="isFeatureIncluded(feature, plan.id)" class="cell-icon">✓</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
